
import socket from './socket'
import { emitter } from './message'

function sendMessage(type, params) {
  var json = { type, ...params }

  console.log(JSON.stringify(json), '参数')
  if (!socket) {
    console.warn('[签字板] WebSocket 未初始化')
    return false
  }
  if (socket.readyState === WebSocket.CONNECTING) {
    console.warn('[签字板] WebSocket 正在连接 127.0.0.1:1919，请稍候')
    return false
  }
  if (socket.readyState !== WebSocket.OPEN) {
    console.warn('[签字板] WebSocket 未连接，readyState=', socket.readyState)
    return false
  }
  try {
    socket.send(JSON.stringify(json))
    return true
  } catch (e) {
    console.error('[签字板] send 失败', e)
    return false
  }
}

// 启动签名板（依赖本机签字客户端监听 ws://127.0.0.1:1919）
export function DoGWQ_SignName(data) {
  return sendMessage(11, data)
}

export function onMessage(evt) {
  console.log(evt, 'evt')
  const obj = JSON.parse(evt.data)
  switch (obj.type) {
    case 11:
      emitter.emit('start-sign', obj)
      break
  }
}

if (socket) {
  socket.onmessage = onMessage
}

export default {
  DoGWQ_SignName
}
